import { render } from "./AverageLocalRanking.vue?vue&type=template&id=54b6ccb8"
import script from "./AverageLocalRanking.vue?vue&type=script&lang=js"
export * from "./AverageLocalRanking.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__